var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBlueTick = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02524 0C12.4164 0 16 3.5836 16 8.02524C16 12.4164 12.4164 16 8.02524 16C3.5836 16 0 12.4164 0 8.02524C0 3.5836 3.5836 0 8.02524 0ZM3.83596 7.92429C3.12934 7.21767 2.01893 8.32808 2.72555 9.0347C3.68454 9.99369 4.54259 10.9527 5.50158 11.8612C5.90536 12.2145 6.25868 12.265 6.61199 11.8612L13.2744 5.19874C13.9811 4.49211 12.9211 3.3817 12.164 4.08833L6.10726 10.1956L3.83596 7.92429Z",
    fill: "#5E66D6"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBlueTick, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/blue-tick.ecb02118.svg";
export { ForwardRef as ReactComponent };